export const CONNECT_BANNER_MIN_HEIGHT = '60px';
export const NAVBAR_HEIGHT_DESKTOP = 80;
export const NAVBAR_HEIGHT_MOBILE = 64;
